<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_rewards', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.reward_images_create">
                {{ $tc('messages.upload_images', 2) }}
            </AppButton>
            <AppButton :href="meta.links.create">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.title') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.description') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.points', 2) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.number_of_times') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(reward, index) in rewards.data"
                                :key="reward.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex items-center space-x-3 lg:pl-2">
                                        <div
                                            :class="[reward.is_negative ? 'bg-red-500' : 'bg-indigo-500']"
                                            class="shrink-0 flex items-center justify-center h-6 w-6 rounded-lg p-1"
                                        >
                                            <img v-if="reward.image_path" :src="reward.image_path" alt="" />
                                        </div>
                                        <!--                                    <div class="shrink-0 w-2.5 h-2.5 rounded-full" :class="[reward.is_negative ? 'bg-red-500' : 'bg-indigo-500']"></div>-->
                                        <span>{{ reward.title }}</span>
                                    </div>
                                </td>
                                <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-500">
                                    {{ reward.description }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div class="flex space-x-1">
                                        <div>
                                            <BadgePill color="green" v-if="reward.experience_amount">
                                                {{ reward.experience_amount }}
                                            </BadgePill>
                                        </div>

                                        <div>
                                            <BadgePill color="yellow" v-if="reward.coins_amount">
                                                {{ reward.coins_amount }}
                                            </BadgePill>
                                        </div>

                                        <div>
                                            <BadgePill color="red" v-if="reward.health_amount">
                                                {{ reward.health_amount }}
                                            </BadgePill>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ reward.currency_points_count }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <!--                                <inertia-square-link-button action="show" :href="reward.links.show"></inertia-square-link-button>-->
                                    <a
                                        v-if="meta.can.attach_image"
                                        :href="reward.links.attach_image"
                                        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        <svg
                                            class="w-4 h-4"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </a>
                                    <InertiaSquareLinkButton action="show" :href="reward.links.show" />
                                    <InertiaSquareLinkButton action="edit" :href="reward.links.edit" />
                                    <InertiaSquareLinkButton action="duplicate" :href="reward.links.duplicate" />
                                    <InertiaSquareDeleteButton :href="reward.links.delete" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="mt-5" v-if="teachers.length">
            <NetworkGraphRewardsTeacher :teachers="teachers" :rewards="rewards.data" />
        </div>

        <form :action="meta.links.index" method="post" @submit.prevent="filter">
            <div class="md:grid sm:grid-cols-12 md:gap-6">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_from')" for="date_from" />
                        <FormInput id="date_from" v-model="form.date_from" type="date" name="date_from" class="mt-1" />
                        <FormError :value="form.errors.date_from" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_to')" for="date_to" />
                        <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1" />
                        <FormError :value="form.errors.date_to" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2 align-bottom">
                    <label class="block text-sm font-medium leading-5 text-gray-700 mt-1"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <template v-slot:pagination>
            <InertiaPagination :paginator="rewards" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import NetworkGraphRewardsTeacher from '@/components/pageSpecific/NetworkGraphRewardsTeacher.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        FormError,
        FormInput,
        FormLabel,
        NetworkGraphRewardsTeacher,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        BadgePill,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'rewards', 'filters', 'teachers', 'gamificationSet'],
    data() {
        return {
            form: this.$inertia.form({
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index, {
                preserveScroll: true,
            });
        },
    },
};
</script>
